<template>
  <div>
    <sports-tabs
      v-if="!isAmp"
      :parentRoute="parentRoute"
      :eventChangeHandler="eventChangeHandler"
    />
    <category-header
      v-if="!isAmp"
      :loadUpdatedContestList="() => !1"
      :parentRoute="parentRoute"
      :loaded_module="loaded_module"
      :eventChangeHandler="eventChangeHandler"
    />
    <carousal
      v-if="!isAmp"
      :parentRoute="parentRoute"
      :loaded_module="loaded_module"
      :componentSlideChnageHandler="eventChangeHandler"
    />
    <page-tabs
      v-if="isAmp"
      :parentRoute="parentRoute"
      :current_match="current_match"
    />
    <page-tabs
      v-else
      :parentRoute="parentRoute"
      :loaded_module="loaded_module"
      :checkIfTourIsActive="() => !1"
      :current_match="current_match"
    />
    <Breadcrumbs
      :parentRoute="parentRoute"
      :current_match="current_match"
      :titleTrans="translations[breadcrumbTransKey]"
      :sequence="[
        {type: 'base', page: 'home'},
        {type: 'module', module: parentRoute, blockSlice: blockBreadcrumbLink},
        {type: 'param', param: 'sport_name', blockSlice: blockBreadcrumbLink},
        {type: 'title'}
      ]"
    />
  </div>
</template>
<script>
import { getMatch } from "../../../assets/js/common";
import SportsTabs from "../../common/SportsTabs";
import CategoryHeader from "./CategoryHeader";
import Carousal from "./Carousel";
import PageTabs from "./PageTabs";
import Breadcrumbs from "../../common/Breadcrumbs";
export default {
  props: ["isAmp", "parentRoute", "loaded_module", "breadcrumbTransKey"],
  components: {
    SportsTabs,
    CategoryHeader,
    Carousal,
    PageTabs,
    Breadcrumbs,
  },
  data() {
    return {
      componentPromises: null,
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
    is_matches_loaded() {
      return this.$store.state.match_detail_store.isMatchesLoaded;
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug() {
      return this.$store.state.match_detail_store.slug;
    },
    in_match_categories() {
      return this.$store.state.match_detail_store.in_match_categories;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug) || {};
    },
    is_pre_match() {
      let curr_match = this.current_match;
      return !!(curr_match && curr_match.status === 1);
    },
    blockBreadcrumbLink() {
      return (this.breadcrumbTransKey.indexOf('scorecard_headline_') > -1);
    }
  },
  methods: {
    eventChangeHandler() {
      this.is_polling = false;
    },
  },
};
</script>